/**
 * Shared avatar utilities — used by TaskCard and TaskDetailModal.
 * `avatarBg` / `getInitials` / `AVATAR_COLORS` are mirrored in
 * `packages/overview/src/avatar.ts`; keep both in sync.
 */

export function getInitials(name: string): string {
  return name
    .split(" ")
    .slice(0, 2)
    .map((p) => p[0])
    .join("")
    .toUpperCase();
}

const AVATAR_COLORS = [
  "#7C83FD", "#5E6AD2", "#26C6F9", "#4CB782",
  "#F2A541", "#E06C75", "#C678DD",
];

export function getAvatarUrl(user: {
  avatarUrl?: string | null;
  messengerAccounts?: Array<{ avatarUrl?: string | null }>;
}): string | undefined {
  return user.messengerAccounts?.[0]?.avatarUrl ?? user.avatarUrl ?? undefined;
}

export function avatarBg(name: string): string {
  let hash = 0;
  for (let i = 0; i < name.length; i++)
    hash = name.charCodeAt(i) + ((hash << 5) - hash);
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}
